const { subDays } = require('date-fns')
const getPeriodFromProgram = require('./get-period-from-program')

module.exports = (program, period) => {
  const previousDate = subDays(new Date(period.entryStartDate), 1).toJSON()
  const previous = getPeriodFromProgram(program, previousDate)
  return previous
}
